export default "__VITE_ASSET__DqA$ZNl2__"